import { ChangeDetectorRef, Component, EventEmitter, OnInit, Output, Input } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Credentials } from '@vestiaire/api-sdk-angular';
import { Store } from '@ngrx/store';
import { IAppState } from '@app/store';
import { PopinAuthShowed, RegisterNewsletter } from '@app/core/user/store/actions';
import { HelpersService } from '@app/shared/services/helpers/helpers.service';
@Component({
  selector: 'vc-form-register-email',
  templateUrl: './form-register-email.component.html',
  styleUrls: ['./form-register-email.component.scss']
})
export class FormRegisterEmailComponent implements OnInit {
  @Output()
  onUserValidated = new EventEmitter<{ credentials: Credentials; firstname?: string }>();
  @Input()
  popinForced: boolean;
  @Input()
  promoOffer: string;

  public isMobile = false;

  public error: string;

  public emailForm: FormGroup;
  public email: FormControl;

  public registerCgu = new FormControl('');

  constructor(private ref: ChangeDetectorRef, private store: Store<IAppState>, private helperService: HelpersService) {}

  ngOnInit() {
    this.createFormControls();
    this.createForm();

    this.store.dispatch(new RegisterNewsletter(null));
    this.isMobile = !this.helperService.device.isMdUp();
    this.store.dispatch(
      new PopinAuthShowed({
        type: 'join',
        forced: this.popinForced,
        isMobile: this.isMobile
      })
    );
  }

  createFormControls() {
    this.email = new FormControl('', [
      Validators.required,
      Validators.pattern(`^[\\w.-]+(\\+[\\w.-]+)?@[\\w.-]+\\.[a-zA-Z]{2,6}$`)
    ]);
  }

  createForm() {
    this.emailForm = new FormGroup({
      email: this.email
    });
  }

  onSubmit() {
    if (this.emailForm.valid) {
      this.onUserValidated.emit({ credentials: { email: this.email.value } });
    }
  }

  setErrorMessage(status: any): void {
    // NEED TO TRANSLATE THIS ERROR MESSAGES

    switch (status) {
      case 409:
        this.error = 'Already exists';
        break;
      case 400:
        this.error = 'The request was invalid or cannot be otherwise served.';
        break;
      default:
        this.error = 'An error has occurred trying to process your request. Please try again later';
    }

    this.ref.detectChanges();
  }

  setUserFromFacebook(user: { credentials: Credentials; firstname?: string }) {
    this.onUserValidated.emit(user);
  }
}
